// --- KEEEP IN SYNC with exports/wallets.native.ts ---
export { createWallet, walletConnect, } from "../wallets/create-wallet.js";
export { inAppWallet, 
/**
 * @deprecated use inAppWallet instead
 */
inAppWallet as embeddedWallet, } from "../wallets/in-app/web/in-app.js";
export { ecosystemWallet } from "../wallets/in-app/web/ecosystem.js";
export { smartWallet } from "../wallets/smart/smart-wallet.js";
// utils
export { getWalletBalance, } from "../wallets/utils/getWalletBalance.js";
export { generateAccount, } from "../wallets/utils/generateAccount.js";
// private-key
export { privateKeyToAccount, 
/**
 * @internal
 * @deprecated - use {@link privateKeyToAccount} instead
 */
privateKeyToAccount as privateKeyAccount, } from "../wallets/private-key.js";
// generate a random private key
export { randomPrivateKey } from "ox/Secp256k1";
export { preAuthenticate, authenticate, authenticateWithRedirect, getUserEmail, getUserPhoneNumber, getProfiles, linkProfile, unlinkProfile, } from "../wallets/in-app/web/lib/auth/index.js";
export { getUser, } from "../wallets/in-app/core/users/getUser.js";
export { getAllWalletsList } from "../wallets/getAllWalletsList.js";
export { getWalletInfo } from "../wallets/__generated__/getWalletInfo.js";
export { createWalletAdapter } from "../adapters/wallet-adapter.js";
// wallet connect
export { createWalletConnectClient, createWalletConnectSession, disconnectWalletConnectSession, getActiveWalletConnectSessions, DefaultWalletConnectRequestHandlers, } from "../wallets/wallet-connect/receiver/index.js";
// eip1193
export * as EIP1193 from "../adapters/eip1193/index.js";
// WEB ONLY EXPORTS
// injected
export { injectedProvider } from "../wallets/injected/mipdStore.js";
export { autoConnect } from "../wallets/connection/autoConnect.js";
export { deploySmartAccount } from "../wallets/smart/lib/signing.js";
//# sourceMappingURL=wallets.js.map